import React from "react";
import {
  Select,
  Checkbox,
  Table,
  Row,
  Col,
  Button,
  Space,
  Dropdown,
  Modal,
  Image,
  Tooltip,
  Popover,
  Popconfirm,
  message,
  Input
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import StudentBusAssignmentStore from "../store/StudentBusAssignmentStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import { Link } from "react-router-dom";
import { CarOutlined, CloseOutlined, FileExcelOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import L from "leaflet";
import Excel from "../assets/images/NewDesign/Excel.svg";
import { GoogleMap, DirectionsRenderer, Marker, InfoWindow } from "@react-google-maps/api";
const { Option } = Select;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
  });

  return arr;
};

class StudentBusAssignmentList extends React.Component {

  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.StudentBusAssignmentStore = new StudentBusAssignmentStore();
    this.vehicleStore = new VehicleStore();
    this.mapRef = React.createRef();

    this.ExportOption = [{
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          {" "}
          <Image
            style={{ height: "18px", width: "18px", borderRadius: "0px" }}
            src={Excel}
          ></Image>
          {context.translate("_ROUTE_MAP_EXCEL_")}
        </div>
      ),
      key: "routeMapexcel",
    },{
      label: (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          {" "}
          <Image
            style={{ height: "18px", width: "18px", borderRadius: "0px" }}
            src={Excel}
          ></Image>
          {context.translate("_STANDARD_DATA_EXCEL_")}
        </div>
      ),
      key: "standardDataExcel",
    }]

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectedgeofenceData: [],
      selectAllVehicles: false,
      selectAllDrivers: false,
      showMonthPopup: false,
      selectAllGeofenceData: false,
      data: "",
      companyId: "",
      Notcompany: false,
      Notasset: false,
      vehicle: false,
      expandedRowKeys: [],
      loadedSummaryData: {},
      selectAllStatus: false,
      status: [],
      innerGridData: [],
      filterNotSelected: false,
      pythonReportMessage: false,
      reportmessage: "",
      toDateNotSelected: false,
      fromDateNotSelected: false,
      garage: "garage",
      viewMap: false,
      studentMapPoints: [],
      plotStudentData: [],
      activeMarker: null,
      selectedpassengerIds: [],
      selectedpassengerIdsByVehicle: {},
      studentSearch: "",
      unassignedOnly: false,

      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("ARABIC_VEHICLE_NO_"),
          dataIndex: "vehicleNoArabic",
          key: "vehicleNoArabic",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_SERATER_"),
          dataIndex: "capacity",
          key: "capacity",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_FLEET_CREATEROUTE_ROUTEADD_TOTALTIME_"),
          dataIndex: "totalTripTime",
          key: "totalTripTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_SCHOOL_1ST_STUDENT_TIME_"),
          dataIndex: "schoolToFirstStudentTime",
          key: "schoolToFirstStudentTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_VEHICLE_1ST_STUDENT_TIME_"),
          dataIndex: "vehicleToFirstStudentTime",
          key: "vehicleToFirstStudentTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_FLEET_CREATEROUTE_ROUTEADD_TOTALDISTANCE_"),
          dataIndex: "totalTripDistance",
          key: "totalTripDistance",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_SCHOOL_1ST_STUDENT_KM_"),
          dataIndex: "schoolToFirstStudentDistanceKm",
          key: "schoolToFirstStudentDistanceKm",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_VEHICLE_1ST_STUDENT_KM_"),
          dataIndex: "vehicleToFirstStudentDistanceKm",
          key: "vehicleToFirstStudentDistanceKm",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_ASSIGNED_COUNT_"),
          dataIndex: "assignedCount",
          key: "assignedCount",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {

          title: context.translate("_ACTION_"),
          dataIndex: "Action",
          // fixed: "right",
          // width: 7,
          ellipsis: true,
          render: (_, record) => {
            return (
              <>
                <Space>

                 <Popconfirm
                    placement="topLeft"
                    title="Assign Vehicle"
                    description="Are you sure you want to assign students to this vehicle?"
                    cancelText="No"
                    okText="Yes"
                    icon={<QuestionCircleOutlined style={{ color: "red" }} />}
                    onConfirm={() => this.updateAssignVehicle(record) }
                  >
                    <CarOutlined
                      style={{
                        paddingLeft: "10px",
                        fontSize: "18px",
                        color: "#1890ff",
                        cursor: "pointer",
                      }}
                    />
                  </Popconfirm>

                  {/* Export Excel for this vehicle only */}
                  <Tooltip title="Export Excel">
                    <FileExcelOutlined
                      style={{
                        fontSize: "18px",
                        color: "#52c41a",
                        cursor: "pointer",
                      }}
                      onClick={async (e) => {
                        e.stopPropagation();
                        await this.StudentBusAssignmentStore.exportStudentVehicleExcel(record);
                      }}
                    />
                  </Tooltip>

                </Space>
              </>
            );
          },
        },

        {
          title: context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_"),
          width: 100,
          key: "view",
          ellipsis: { showTitle: true },
          render: (value, obj) => {
            return (
              <>
                <Link
                  onClick={async (e) => {
                    await this.showStudentMap(obj);
                  }}
                >
                  {" "}
                  <img
                    src={require("../assets/images/mapIcon/gps_icon.png")}
                    width={25}
                    height={25}
                  />
                </Link>
              </>
            );
          },
        },

      ]),
    };

    this.menuProps = {
      items: this.ExportOption,
      onClick: async (val) => {
        let result = [];
        if (true) {

          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            garage: this.state.fromVehicleLocation ? "" : this.state.garage,
            fromVehicleLocation: this.state.fromVehicleLocation,
            unassignedOnly: this.state.unassignedOnly,
            interval: this.state.interval,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            colList: result.toString(),
          };

          if (val.key == "routeMapexcel") {
            await this.StudentBusAssignmentStore.routeMapexcel(getData);
            const isSuccess =
              this.StudentBusAssignmentStore?.pythonReportMessage === true;
            const isError = this.StudentBusAssignmentStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }else if (val.key == "standardDataExcel") {
            await this.StudentBusAssignmentStore.standardDataExcel(getData);
            const isSuccess =
              this.StudentBusAssignmentStore?.pythonReportMessage === true;
            const isError = this.StudentBusAssignmentStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.state.viewMap !== prevState.viewMap) {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      });
    }
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedgeofenceData: [],
      selectAllGeofenceData: false,
    });

    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    await this.setState({ loadData: 1 });
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.showData();
  }

  updateAssignVehicle = async (record) => {

    try {

      const selectedPassengerIds =
        this.state.selectedpassengerIdsByVehicle?.[record.vehicleId] ?? [];

      const passengerData = {
        vehicleId: record.vehicleId,
        passengerIds: selectedPassengerIds,
      };

      const response =
        await this.StudentBusAssignmentStore.updateAssignVehicle(passengerData);

      if (response) {
        message.success("Vehicle assigned successfully");
      } else {
        message.error("Unable to assign vehicle");
      }
    } catch (error) {
      message.error("Something went wrong");
    }

  };

  showData = async () => {
    this.setState({ expandedRowKeys: [] });

    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
      return;
    }else {
      this.setState({ Notcompany: false });
    }

    if (this.state.unassignedOnly && this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
      return;
    } else {
      this.setState({ Notasset: false });
    }

    const resp = await this.StudentBusAssignmentStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
      garage: this.state.fromVehicleLocation ? "" : this.state.garage,
      fromVehicleLocation: this.state.fromVehicleLocation,
      unassignedOnly: this.state.unassignedOnly,
      pageNo: this.state.currentPage,
    });

    // ✅ use response directly OR read store after await settles
    const data = resp?.data ||
      this.StudentBusAssignmentStore.studentAssignmentStore || [];

    // console.log("data after load:", data); // 👈 check this first

    const selectedpassengerIdsByVehicle = {};

    data.forEach((vehicle) => {
      selectedpassengerIdsByVehicle[vehicle.vehicleId] =
        (vehicle.studentList || [])
          .map((s) => s.passengerId)
          .filter((id) => id != null);
    });

    // console.log("selectedpassengerIdsByVehicle:", selectedpassengerIdsByVehicle); // 👈 check this

    this.setState({
      selectedpassengerIdsByVehicle,
      loadData: 1,
    });
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId?.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  onExpand = async (expanded, record) => {
    // console.log(record)
    this.setState({
      expandedRowKeys: expanded ? [record.vehicleId] : [],
    });

  };

  getExpandedColumns = () => {

    const allColumns = [
      {
        title: this.context.translate("_STUDENT_NAME_"),
        dataIndex: "studentName",
        key: "studentName",
        width: 30
        // width: "10%",
      },
      {
        title: this.context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_LOCATION_"),
        dataIndex: "pickUpPoint",
        key: "pickUpPoint",
        width: 200
        // width: "10%",
      },
      {
        title: this.context.translate("_FLEET_DASHBORD_HISTORY_TOOLTIP_MOBILE_"),
        dataIndex: "mobileNo",
        key: "mobileNo",
        width: 20
        // width: "10%",
      },
      {
        title: this.context.translate("_FLEET_REPORTS_STOPREPORT_ARRIVALTIME_"),
        dataIndex: "legTime",
        key: "legTime",
        width: 15
        // width: "10%",
      },
      {
        title: this.context.translate("_DISTANCE_"),
        dataIndex: "legDistanceKm",
        key: "legDistanceKm",
        width: 15
        // width: "10%",
      }
    ];

    return allColumns

  };

  expandedRowRender = (record) => {
    const columns = this.getExpandedColumns();

    const studentList = record.studentList || [];

    const searchText = this.state.studentSearch || "";

    const filteredStudents = studentList.filter((item) =>
      item.studentName
        ?.toLowerCase()
        .includes(searchText.toLowerCase())
    );

    const selectedIds =
      this.state.selectedpassengerIdsByVehicle?.[record.vehicleId];

    const finalSelectedIds =
      selectedIds ??
      studentList
        .map((x) => x.passengerId)
        .filter((id) => id != null);

    const rowSelection = {
      selectedRowKeys: finalSelectedIds,

      onChange: (keys) => {

        const cleanKeys = keys.filter((id) => id != null);

        this.setState((prev) => ({
          selectedpassengerIdsByVehicle: {
            ...prev.selectedpassengerIdsByVehicle,
            [record.vehicleId]: cleanKeys,
          },
        }));

      },

      preserveSelectedRowKeys: true,
      columnWidth: 10,
    };

    return (
      <div className="innerGridTbl">
        <input
          placeholder="Search Student"
          value={this.state.studentSearch}
          onChange={(e) =>
            this.setState({ studentSearch: e.target.value })
          }
          style={{
            width: 180,
            marginBottom: 8,
            padding: 5,
            border: "1px solid #d9d9d9",
            borderRadius: 4,
          }}
        />

        <Table
          className="studentExpandedTable"
          bordered
          size="small"
          pagination={false}
          columns={columns}
          dataSource={filteredStudents}
          rowKey={(row) => row.passengerId}
          rowSelection={rowSelection}
        />
      </div>
    );
  };

  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  // ── Map helpers (student lat/long + route) ──────────────────────────────
  showStudentMap = (record) => {
    const points = (record.studentList || [])
      .filter((s) => s.pickupLat && s.pickupLong)
      .map((s) => ({
        lat: parseFloat(s.pickupLat),
        lng: parseFloat(s.pickupLong),
        name: s.studentName || "Student",
        pickUpPoint: s.pickUpPoint || "",
      }));
    this.pendingMapPoints = points;


    this.setState({ viewMap: true }, () => {
      // setState callback — runs after render, map is visible
      setTimeout(() => this.drawStudentMarkers(), 400);
    });
  };

  // showStudentMap = (record) => {
  //   const used = {};

  //   const points = (record.studentList || []).map((s) => {
  //     let lat = parseFloat(s.pickupLat);
  //     let lng = parseFloat(s.pickupLong);

  //     const key = `${lat},${lng}`;
  //     used[key] = (used[key] || 0) + 1;

  //     const count = used[key] - 1;

  //     // Offset duplicates slightly
  //     lat = lat + count * 0.00015;
  //     lng = lng + count * 0.00015;

  //     return {
  //       lat,
  //       lng,
  //       name: s.studentName || "Student",
  //       pickUpPoint: s.pickUpPoint || "",
  //     };
  //   });

  //   this.pendingMapPoints = points;

  //   this.setState({ viewMap: true }, () => {
  //     setTimeout(() => this.drawStudentMarkers(), 400);
  //   });
  // };

  drawStudentMarkers = () => {
    const map = this.mapRef.current;
    if (!map) return;

    const points = this.pendingMapPoints || [];
    if (points.length === 0) return;

    // Clear old markers only
    map.eachLayer((layer) => {
      if (layer instanceof L.Marker || layer instanceof L.CircleMarker) {
        map.removeLayer(layer);
      }
    });

    // Group consecutive same coordinates
    const groups = [];
    let current = null;

    points.forEach((p, index) => {
      const key = `${p.lat},${p.lng}`;
      const seq = index + 1;

      if (!current || current.key !== key) {
        current = {
          key,
          lat: p.lat,
          lng: p.lng,
          startSeq: seq,
          endSeq: seq,
          pickUpPoint: p.pickUpPoint || "",
          students: [{ ...p, seq }],
        };

        groups.push(current);
      } else {
        current.endSeq = seq;
        current.students.push({ ...p, seq });
        current.endSeq = seq;
      }
    });

    // Plot markers only
    groups.forEach((g, index) => {
      const isFirst = index === 0;
      const isLast = index === groups.length - 1;

      let color = "#1890ff"; // middle

      if (isFirst) color = "#52c41a"; // green
      if (isLast) color = "#f5222d"; // red

      const label =
        g.startSeq === g.endSeq
          ? `${g.startSeq}`
          : `${g.startSeq}-${g.endSeq}`;

      const icon = L.divIcon({
        className: "",
        html: `
          <div style="
            width:38px;
            height:38px;
            border-radius:50%;
            background:${color};
            border:2px solid #fff;
            display:flex;
            align-items:center;
            justify-content:center;
            color:#fff;
            font-size:11px;
            font-weight:bold;
            box-shadow:0 2px 6px rgba(0,0,0,.35);
          ">
            ${label}
          </div>
        `,
        iconSize: [38, 38],
        iconAnchor: [19, 19],
      });

      const popupHtml = `
        <div style="min-width:180px">
          <b>Stop ${label}</b><br/>
          <b>${g.pickUpPoint}</b><br/><br/>
          ${g.students.map((s) => `${s.seq}. ${s.name}`).join("<br/>")}
        </div>
      `;

      L.marker([g.lat, g.lng], { icon })
        .addTo(map)
        .bindPopup(popupHtml);
    });

    // Fit markers in view
    const bounds = groups.map((g) => [g.lat, g.lng]);

    if (bounds.length > 1) {
      map.fitBounds(bounds, {
        padding: [40, 40],
        maxZoom: 15,
      });
    } else {
      map.setView(bounds[0], 15);
    }
  };

  closeStudentMap = () => {
    const map = this.mapRef.current;
    if (map) {
      map.eachLayer((layer) => {
        if (layer instanceof L.Marker || layer instanceof L.Polyline) {
          map.removeLayer(layer);
        }
      });
    }
    this.pendingMapPoints = [];

    this.setState({ viewMap: false, directions: null, activeMarker: null });
  };
  // ────────────────────────────────────────────────────────────────────────

  getRoute = async () => {
    const { pendingMapPoints } = this;

    if (!window.google || !window.google.maps) return;
    if (!pendingMapPoints || pendingMapPoints.length < 2) return;

    const directionsService = new window.google.maps.DirectionsService();

    const chunks = this.chunkPoints(pendingMapPoints);

    const routes = [];

    for (let i = 0; i < chunks.length; i++) {
      const segment = chunks[i];

      const origin = segment[0];
      const destination = segment[segment.length - 1];

      const waypoints = segment.slice(1, -1).map(p => ({
        location: { lat: p.lat, lng: p.lng },
        stopover: true,
      }));

      const request = {
        origin,
        destination,
        waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
      };

      try {
        const result = await new Promise((resolve, reject) => {
          directionsService.route(request, (res, status) => {
            if (status === "OK") resolve(res);
            else reject(status);
          });
        });

        routes.push(result);

      } catch (err) {
        console.error("Segment failed:", err);
      }
    }

    this.setState({
      directionsList: routes,
      center: pendingMapPoints[0],
    });
  };

  chunkPoints(points) {
    const MAX_POINTS = 25;
    const chunks = [];

    for (let i = 0; i < points.length; i += (MAX_POINTS - 1)) {
      chunks.push(points.slice(i, i + MAX_POINTS));
    }

    return chunks;
  }

  buildRouteMarkers = () => {
    const { directionsList } = this.state;
    const original = this.pendingMapPoints || [];

    if (!directionsList) return [];

    const markers = [];

    let indexCounter = 0;

    directionsList.forEach((dir) => {
      const legs = dir.routes[0].legs;

      legs.forEach((leg) => {
        // first point
        if (markers.length === 0) {
          markers.push({
            lat: leg.start_location.lat(),
            lng: leg.start_location.lng(),
            name: original[indexCounter]?.name,
            address: original[indexCounter]?.address,
          });
          indexCounter++;
        }

        // each stop
        markers.push({
          lat: leg.end_location.lat(),
          lng: leg.end_location.lng(),
          name: original[indexCounter]?.name,
          address: original[indexCounter]?.pickUpPoint,
        });

        indexCounter++;
      });
    });

    return markers;
  };

  buildGroupedMarkers = () => {
    const markers = this.buildRouteMarkers();

    const grouped = {};

    markers.forEach((point, index) => {
      const key = `${point.lat.toFixed(5)}-${point.lng.toFixed(5)}`;

      if (!grouped[key]) {
        grouped[key] = {
          lat: point.lat,
          lng: point.lng,
          indexes: [],
          names: [],
          addresses: [],
          isSchool: false,
        };
      }

      grouped[key].indexes.push(index + 1);
      grouped[key].names.push(point.name);
      grouped[key].addresses.push(point.address);
      if (point.name?.toLowerCase().includes("school")) {
        grouped[key].isSchool = true;
      }
    });

    return Object.values(grouped);
  };
  render() {
    const groupedMarkers = this.buildGroupedMarkers();

    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  className="searchInput"
                  allowClear={true}
                  style={{ width: 150 }}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <>
                    <DeviceGroupsForVehicles
                      vehicleStore={this.vehicleStore}
                      setLoadDta={() => this.setState({ loadData: 1 })}
                      resetVehicles={() =>
                        this.setState({
                          selectedVehicles: [],
                          selectAllVehicles: false,
                        })
                      }
                    />
                  </>
                )}



                <>
                  <Checkbox
                    checked={this.state.unassignedOnly}
                    onChange={(e) => {

                      this.setState(
                        {
                          unassignedOnly: e.target.checked,
                          selectedVehicles: [],
                          selectAllVehicles: false,
                        },
                        async () => {
                          await this.vehicleStore.getVehiclesCompanyId(this.state.companyId,e.target.checked);
                          this.setState({loadData :1})
                        }
                      );
                    }}
                  />
                  {this.context.translate("_UNASSIGNED_ONLY_")}

                  <Checkbox
                    checked={this.state.selectAllVehicles}
                    onChange={async (e) => {
                      await this.setState({
                        selectAllVehicles: e.target.checked,
                      });
                      if (this.state.selectAllVehicles) {
                        await this.setState({
                          Notasset: false,
                        });
                      }
                      await this.handleAllSelectVehicles();
                    }}
                  />

                  {this.context.translate("_ALL_")}

                  <Select
                    maxTagCount="responsive"
                    className="searchInput"
                    value={this.state.selectedVehicles}
                    onChange={(val) => {
                      this.setState({ selectedVehicles: val });
                      if (
                        this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                        val.length
                      ) {
                        this.setState({ selectAllVehicles: false });
                      } else {
                        this.setState({ selectAllVehicles: true });
                      }

                      if (val?.length > 1) {
                        this.setState({ showAlertPopup: true });
                      }
                    }}
                    style={{ width: 180 }}
                    showSearch
                    status={this.state.Notasset ? "error" : false}
                    mode="multiple"
                    placeholder={this.context.translate(
                      "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                    )}
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                      (val) => {
                        return (
                          <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                        );
                      }
                    )}
                  </Select>
                </>
                {
                  <Select
                    defaultValue={this.context.translate("_GARAGE_")}
                    style={{ width: 100 }}
                    onSelect={(garage) => this.setState({ garage: garage })}
                    placeholder={this.context.translate("_START_LOCATION_")}
                    className="searchInput"
                    disabled={this.state.fromVehicleLocation}
                  >
                    <Select.Option value="garage">{this.context.translate("_GARAGE_")}</Select.Option>
                  </Select>}

                <Checkbox
                  checked={this.state.fromVehicleLocation}
                  onChange={async (e) => {
                    await this.setState({
                      fromVehicleLocation: e.target.checked,
                    });

                  }}
                />
                {this.context.translate("_FROM_VEHICLE_LOCATION_")}

                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                  }}
                >
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>

                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.StudentBusAssignmentStore?.studentAssignmentStore?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.menuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>
          {/* SUMMARY CARDS START */}
          <Row gutter={16} style={{ marginBottom: 15, marginTop: 15 }}>
            <Col span={6}>
              <div className="summaryCard">
                <h4>Total Students</h4>
                <h2>{this.StudentBusAssignmentStore?.summary?.totalStudents || 0}</h2>
              </div>
            </Col>

            <Col span={6}>
              <div className="summaryCard">
                <h4>Assigned Students</h4>
                <h2>{this.StudentBusAssignmentStore?.summary?.assignedStudents || 0}</h2>
              </div>
            </Col>

            <Col span={6}>
              <div className="summaryCard">
                <h4>Buses Used</h4>
                <h2>{this.StudentBusAssignmentStore?.summary?.busesUsed || 0}</h2>
              </div>
            </Col>

            <Col span={6}>
              <div className="summaryCard">
                <h4>Available Buses</h4>
                <h2>{this.StudentBusAssignmentStore?.summary?.busesAvailable || 0}</h2>
              </div>
            </Col>
          </Row>
          {/* SUMMARY CARDS END */}
          <ListTable
            rowKey="vehicleId"
            key={this.state.selectedColumns.length}
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            columns={this.state.column}
            total={this.StudentBusAssignmentStore?.total}
            dataSource={this.StudentBusAssignmentStore?.studentAssignmentStore}
            loading={this.StudentBusAssignmentStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
        {/* ── Student Location & Route Map Modal ───────────────────────── */}

        <Modal
          className="multiTracking-popup"
          maskClosable={false}
          title={
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span>{this.context.translate("_FLEET_SERVICE_POILIST_VIEWMAP_")}</span>
              <CloseOutlined onClick={() => this.closeStudentMap()} />
            </div>
          }
          open={this.state.viewMap}
          centered
          bodyStyle={{ height: "55vh" }}
          width={1000}
          footer={false}
        >
          <div style={{ height: "55vh" }}>

            <GoogleMap
              key={JSON.stringify(this.pendingMapPoints)}
              mapContainerStyle={{ height: "55vh", width: "100%" }}
              zoom={13}
              center={{ lat: 24.7136, lng: 46.6753 }}
              onLoad={(map) => {
                this.getRoute();
              }}
            >
              {this.state.directionsList?.map((dir, i) => (
                <DirectionsRenderer key={i} directions={dir} options={{ suppressMarkers: true }} />
              ))}

              {groupedMarkers.map((point, index) => {
                const labelText = point.indexes.join("-");

                const isFirst = point.indexes.includes(1);
                const isLast = point.isSchool;

                return (
                  <Marker
                    key={index}
                    position={{ lat: point.lat, lng: point.lng }}
                    onClick={() => this.setState({ activeMarker: index })}
                    label={{
                      text: labelText,
                      color: "#fff",
                      fontSize: "9px",
                      fontWeight: "bold"
                    }}
                    icon={{
                      path: window.google.maps.SymbolPath.CIRCLE,
                      scale: 18,
                      fillColor: isFirst
                        ? "#52c41a"
                        : isLast
                          ? "#f5222d"
                          : "#1890ff",
                      fillOpacity: 1,
                      strokeColor: "#fff",
                      strokeWeight: 2,
                    }}
                  >

                    {this.state.activeMarker === index && (
                      <InfoWindow
                        onCloseClick={() => this.setState({ activeMarker: null })}
                      >
                        <div style={{
                          width: "220px",          // ✅ fixed width
                          minHeight: "80px",
                        }}>
                          <strong>Stops:</strong> {labelText}

                          <div style={{ marginTop: "6px" }}>
                            <strong>Students:</strong>
                            {point.names && point.names.length > 0 ? (
                              <ul style={{ paddingLeft: "16px", margin: 0 }}>
                                {point.names.map((name, i) => (
                                  <li key={i}>
                                    <div>{name}</div>
                                    <div style={{ fontSize: "10px", color: "#888" }}>
                                      {point.addresses[i] || "-"}
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            ) : (
                              <div style={{ color: "#999", marginTop: "4px" }}>
                                No data available
                              </div>
                            )}
                          </div>
                        </div>
                      </InfoWindow>
                    )}

                  </Marker>
                );
              })}
            </GoogleMap>

          </div>
        </Modal>
        {/* ──────────────────────────────────────────────────────────────── */}
      </>
    );
  }
}
StudentBusAssignmentList.contextType = StoreContext;
export default observer(withRouter(StudentBusAssignmentList));
